let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7NtHo")).then(() => parcelRequire('7enjy'));